module.exports = __webpack_public_path__ + "static/bbb_logo-51789fe07b3f8214e40597bcf264d6b7.png";